export default "/_next/static/images/error-img-3f61082296de4a79930f7bf81c890461.svg";